
import Vue from "vue";

export default Vue.extend({
  name: "entry-restricted-popup-alert",
  methods: {
    okClicked() {
      this.$emit("close-entryRestricted-popup");
    },
  },
  computed: {
    getImgSrcset(): string {
      return `${require("@/assets/images/entryRestricted-popup@2x.svg")} 2x, 
        ${require("@/assets/images/entryRestricted-popup.svg")} 1x`;
    },
  },
});
